export default __webpack_public_path__ + "static/media/452.43cc60dc.png";